angular
	.module('empower.contactUs')
	.constant('feedbackWording', {
		REQUIRED_POLICY: 'Policy is required',
		REQUIRED_CLAIM: 'Claim is required',
		SEND_FEEDBACK_SUCCESS: 'Thank you, your feedback/enquiry has been sent to EML and we will get back to you within 2 working days.',
		SEND_FEEDBACK_FAILED: 'An error has occurred when attempting to send email to Empower. Please check that you are connected to the internet.',
		MESSAGE_TOO_LONG: 'Message is too long. Only maximum 500 characters allowed'
	});